import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[ariaSort]',
  standalone: true,
})
export class AriaSortDirective implements OnChanges {
  @Input() ariaSort: string;
  @Input() sortBy: string;
  @Input() reverse: boolean;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['sortBy'] || changes['reverse']) {
      if (this.ariaSort === this.sortBy) {
        this.elementRef.nativeElement.setAttribute(
          'aria-sort',
          this.reverse ? 'descending' : 'ascending',
        );
      } else {
        this.elementRef.nativeElement.removeAttribute('aria-sort');
      }
    }
  }
}
